<template>
<div class="video-popup" v-if="isShowPopup" @click.stop="closeVideo">
  <div class="video-content">
    <video controls :src="videoUrl" autoplay @click.stop></video>
    <div @click.stop="closeVideo" class="close-btn">
      <img src="https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-modal-close.png" alt="">
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    videoUrl:{
      type: String,
      default: ''
    },
    isShow:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowPopup:false
    }
  },
  watch:{
    isShow(newVal){
      this.isShowPopup = newVal
    }
  },
  methods:{
    closeVideo(){
      this.isShowPopup = false
      this.$emit('closeVideo',false)
    }
  }
}
</script>
<style scoped lang="less">
.video-popup{
  width: 100%;
  height: 100vh;
  position: fixed;
  background: rgba(0,0,0,0.5);
  z-index: 1;
  top: 0;
  left: 0;
}
.video-content{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  & video{
    width: 100%;
    height: 100%;
  }
  .close-btn{
    position: absolute;
    width: 40px;
    height: 40px;
    top: 15px;
    right: 15px;
    border-radius: 26px;
    overflow: hidden;
    cursor: pointer;
    img{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>